import type { SearchPageVariants } from "./utils/posthog";

export type TransNamespace = `transfer:${string}`;

export const ACCOUNT_TYPE = {
  TRAVELER: "TRAVELER",
  TRAVEL_AGENT: "TRAVEL_AGENT",
} as const;

export type AccountType = (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];

export const TRAVEL_AGENT_POSITION = {
  MASTER: 1,
  SLAVE: 0,
} as const;

export type TravelAgentPosition =
  (typeof TRAVEL_AGENT_POSITION)[keyof typeof TRAVEL_AGENT_POSITION];

export type Country = {
  name?: string;
  callingCode: string;
  code: string;
};

export type Passenger = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  country?: Country;
  uid?: string;
};

export type SearchParams = {
  search_id?: string;
  result_id?: string;
  from_path?: string;
  trip_id?: string;
  session_id?: string;
  ref?: string;
  utm_campaign?: string;
  branch?: string;
  mode?: string;
  num_passengers?: number | string;
  currency?: string;
  start_address?: string;
  start_name?: string;
  flight_datetime?: string;
  pickup_datetime?: string;
  end_address?: string;
  end_name?: string;
  return_flight_datetime?: string;
  return_pickup_datetime?: string;
  airline?: string;
  flight_number?: number | string;
  airline2?: string;
  flight_number2?: number | string;
  dial_code?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string | number;
  coupon_code?: string | number;
  partner_tracking_id?: string | number;
  customer_special_instructions?: string;
  srp_variant?: SearchPageVariants;
};

export type CouponCode = {
  value: string;
  status: "idle" | "success" | "error";
  message?: string;
};

export type AvailablePaymentOption = {
  brand: string;
  expMonth: number;
  expYear: number;
  firstName: string;
  last4: string;
  lastName: string;
  name: string;
  number: string;
  paymentMethodId: string;
};

export const PRICE_CHECK_STATUS = {
  PRICE_CHANGED: "PRICE_CHANGED",
  PRICE_UNCHANGED: "PRICE_UNCHANGED",
  NOT_AVAILABLE: "NOT_AVAILABLE",
} as const;

export type Location = {
  name: string;
  iconUrl: string;
  lat?: number;
  lng?: number;
};

export type Mode = "one_way" | "round_trip";

export type CustomerFeedbackRating = 1 | 2 | 3 | 4 | 5;

export type DecodedJWT = {
  payload: {
    exp: number;
    iat: number;
    jti: string;
    user_id: number;
    email: string;
    username: string;
  };
};
